import { render, staticRenderFns } from "./appConfiguration.vue?vue&type=template&id=1b13b91a&scoped=true"
import script from "./appConfiguration.vue?vue&type=script&lang=js"
export * from "./appConfiguration.vue?vue&type=script&lang=js"
import style0 from "./appConfiguration.vue?vue&type=style&index=0&id=1b13b91a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b13b91a",
  null
  
)

export default component.exports